import dayjs from 'dayjs';

export const resolvePeriodRange = (
  period: string,
  userTZ: string | undefined
): { start: string; end: string } | null => {
  const tz = userTZ || dayjs.tz.guess();
  const today = dayjs().tz(tz);
  const fmt = (d: dayjs.Dayjs) => d.format('YYYY-MM-DD');
  const p = period.trim().toLowerCase();
  if (p === 'today') {
    return { start: fmt(today), end: fmt(today) };
  }
  if (p === 'yesterday') {
    return {
      start: fmt(today.subtract(1, 'day')),
      end: fmt(today.subtract(1, 'day')),
    };
  }
  if (p === 'last week') {
    return {
      start: fmt(today.subtract(1, 'week').startOf('week')),
      end: fmt(today.subtract(1, 'week').endOf('week')),
    };
  }
  if (p === 'last month') {
    return {
      start: fmt(today.subtract(1, 'month').startOf('month')),
      end: fmt(today.subtract(1, 'month').endOf('month')),
    };
  }
  if (p === 'week to date') {
    return {
      start: fmt(today.startOf('week')),
      end: fmt(today),
    };
  }
  if (p === 'last 24 hours') {
    return {
      start: fmt(today.clone().subtract(1, 'day')),
      end: fmt(today),
    };
  }
  if (p === 'last 7 days') {
    return {
      start: fmt(today.clone().subtract(6, 'day')),
      end: fmt(today),
    };
  }

  if (p === 'last 30 days') {
    return {
      start: fmt(today.clone().subtract(29, 'day')),
      end: fmt(today),
    };
  }

  if (p === 'month to date') {
    return {
      start: fmt(today.clone().startOf('month')),
      end: fmt(today),
    };
  }

  if (p === 'quarter to date') {
    const qStartMonth = Math.floor(today.month() / 3) * 3;
    const start = today.clone().month(qStartMonth).startOf('month');
    return {
      start: fmt(start),
      end: fmt(today),
    };
  }

  if (p === 'year to date') {
    return {
      start: fmt(today.clone().startOf('year')),
      end: fmt(today),
    };
  }
  if (p === 'All time'.toLowerCase()) {
    return {
      start: null,
      end: fmt(today),
    };
  }

  const monthCandidate = dayjs(period, 'MMMM YYYY', true);
  if (monthCandidate.isValid()) {
    return {
      start: fmt(monthCandidate.startOf('month')),
      end: fmt(monthCandidate.endOf('month')),
    };
  }

  return null;
};
